import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface RecentlyViewedStore {
  handles: string[];
  add: (handle: string) => void;
}

export const useRecentlyViewedStore = create<RecentlyViewedStore>()(
  persist(
    (set, get) => ({
      handles: [],
      add: (handle) => {
        const { handles } = get();
        const filtered = handles.filter((h) => h !== handle);
        set({ handles: [handle, ...filtered].slice(0, 12) });
      },
    }),
    {
      name: 'loftloom-recently-viewed',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
